import Vue from 'vue'
Vue.prototype.$myMsg = function(res){
    res = res.data ? res.data : res;
    this.$message({
        type: res.type || res.status == '3'?'success':'error',
        message: res.message || res.msg,
        duration: res.duration || 2000,
    });
    return (res.status || res.type)
}

//fix toFixed 某些情况下出错
// Number.prototype.toFixed=function(len) {
//     var tempNum = 0;
//     var s, temp;
//     var s1 = this + "";
//     var start = s1.indexOf(".");
  
//     //截取小数点后,0之后的数字，判断是否大于5，如果大于5这入为1
  
//     if (start >= 0 && s1.substr(start + len + 1, 1) >= 5)
//       tempNum = 1;
  
//     //计算10的len次方,把原数字扩大它要保留的小数位数的倍数
//     var temp = Math.pow(10, len);
//     //求最接近this * temp的最小数字
//     //floor() 方法执行的是向下取整计算，它返回的是小于或等于函数参数，并且与之最接近的整数
//     s = Math.floor(this * temp) + tempNum;
//     return  s/temp;
// }

Number.prototype.toFixed=function(d){
    var s = this + "";
    if (!d) d = 0;
    if (typeof d == 'string') {
        d = Number(d);
    };
    if (s.indexOf(".") == -1) {
        s += ".";
    };
    s = scienceNum(s); //处理e+、e-情况
    s += new Array(d + 1).join("0");
    if (new RegExp("^(-|\\+)?(\\d+(\\.\\d{0," + (d + 1) + "})?)\\d*$").test(s)) {
        var _s = "0" + RegExp.$2,
            pm = RegExp.$1,
            a = RegExp.$3.length,
            b = true;
        if (a == d + 2) {
            a = _s.match(/\d/g);
            if (parseInt(a[a.length - 1]) > 4) {
                for (var i = a.length - 2; i >= 0; i--) {
                    a[i] = parseInt(a[i]) + 1;
                    if (a[i] == 10) {
                        a[i] = 0;
                        b = i != 1;
                    } else break;
                }
            }
            _s = a.join("").replace(new RegExp("(\\d+)(\\d{" + d + "})\\d$"), "$1.$2");
        }
        if (b) {
            _s = _s.substr(1);
        };
        return (pm + _s).replace(/\.$/, "");
    }
    return this + "";
}
/**
 * 将数值转为字符串
 * 
 * 通过移动小数点  扩大倍数或缩小倍数(解决出现e+、e-的问题)
 * 
 * JavaScript在以下情景会自动将数值转换为科学计数法：
 *   1）小数点前的数字多于21位。
 *   2）小数点后的零多于5个
 */
function scienceNum(value) {
    if (!value) {
        return value;
    }
    if (typeof value === 'number') {
        value = value + ""
    };
    var eIndex = value.indexOf('E');
    if (eIndex == -1) {
        eIndex = value.indexOf('e')
    };
    if (eIndex != -1) {
        var doubleStr = value.substring(0, eIndex); //e前面的值
        var eStr = parseInt(value.substring(eIndex + 1, value.length)); //e后面的值
        var doubleStrArr = doubleStr.split('.');
        var doubleStr1 = doubleStrArr[0] || "";
        var doubleStr2 = doubleStrArr[1] || "";

        if (eStr < 0) { //e- 很小的数
            var str1Len = doubleStr1.length;
            var eStrs = Math.abs(eStr);
            if (str1Len > eStrs) {
                var nums = doubleStr1.substring(0, eStrs);
                var nume = doubleStr1.substring(eStrs, str1Len);
                doubleStr = nums + "." + nume + nume;
            } else if (str1Len < eStrs) {
                var indexNum = eStrs - str1Len;
                var str = _makeZero(indexNum); //用0补齐
                doubleStr = '0.' + str + doubleStr1 + doubleStr2;
            } else {
                doubleStr = '0.' + doubleStr1 + doubleStr2;
            }
        } else { //e+ 很大的数
            var str2Len = doubleStr2.length;
            if (str2Len > eStr) {
                var _nums = doubleStr2.substring(0, eStr);
                var _nume = doubleStr2.substring(eStr, str2Len);
                doubleStr = doubleStr1 + _nums + '.' + _nume;
            } else if (str2Len < eStr) {
                var _indexNum = eStr - str2Len;
                var _str = _makeZero(_indexNum); //用0补齐
                doubleStr = doubleStr1 + doubleStr2 + _str;
            } else {
                doubleStr = doubleStr1 + doubleStr2;
            }
        }
        value = doubleStr;
    }
    return value;
}


// WEBPACK FOOTER //
// ./src/server/methods.js